// pdp-shipping-calculator.js
"use strict";

// Configurações fixas – ajuste conforme sua necessidade.
const SHIPPING_COUNTRY = "BR"; // País fixo
const SHIPPING_PROVINCE = "SP"; // Estado fixo

// Elementos da PDP
const estimatorWrap = document.querySelector("[data-estimate-shipping-wrap]");
const cepInput = document.getElementById("ShippingZip_" + (estimatorWrap ? estimatorWrap.getAttribute("data-id") : ""));
const estimateBtn = document.querySelector("[data-action='estimate-shipping']");
const responseRatesContainer = document.querySelector("[data-response-rates]");

// Variável para armazenar a key do item temporário (se adicionado)
let tempCartItemKey = null;

// Função para atualizar o CEP salvo no localStorage
function saveCep(cep) {
  localStorage.setItem("shipping_cep", cep);
  localStorage.setItem("user_cep", cep);
}

// Função para obter o CEP salvo
function getSavedCep() {
  return localStorage.getItem("shipping_cep") || "";
}

// Função para buscar os dados do carrinho (usando /cart.js)
function fetchCart() {
  return fetch("/cart.js")
    .then(response => response.json());
}

// Função para adicionar temporariamente o produto atual no carrinho
function addTemporaryProduct() {
  return new Promise((resolve, reject) => {
    // Usa a variável global definida no template
    const variantId = window.currentProductVariantId;
    if (!variantId) {
      return reject("Variant ID não definido.");
    }
    console.log("ID da variação usado para cálculo do frete:", variantId);
    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", 1);
    
    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      credentials: "same-origin"
    })
    .then(response => response.json())
    .then(data => {
      console.log("Produto temporário adicionado:", data);
      tempCartItemKey = data.key;
      resolve(data);
    })
    .catch(error => reject(error));
  });
}

// Função para remover o produto temporário do carrinho
function removeTemporaryProduct(retryCount = 0) {
  if (!tempCartItemKey) return Promise.resolve();

  // Uso de URLSearchParams para enviar os dados como query string
  const params = new URLSearchParams();
  params.append("id", tempCartItemKey);
  params.append("quantity", "0");

  return fetch("/cart/change.js", {
    method: "POST",
    body: params,
    credentials: "same-origin"
  })
  .then(response => response.json())
  .then(data => {
    console.log("Produto temporário removido:", data);
    tempCartItemKey = null; // Limpa a chave
    return data;
  })
  .catch(error => {
    console.error("Erro ao remover produto temporário (tentativa " + (retryCount + 1) + "):", error);
    if (retryCount < 2) { // tenta no máximo 3 vezes
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve(removeTemporaryProduct(retryCount + 1));
        }, 2000);
      });
    }
    throw error;
  });
}

// Função para chamar a API de shipping rates
function fetchShippingRates(cep) {
  const url = `/cart/shipping_rates.json?shipping_address[zip]=${encodeURIComponent(cep)}&shipping_address[country]=${SHIPPING_COUNTRY}&shipping_address[province]=${SHIPPING_PROVINCE}`;
  return fetch(url)
    .then(response => {
      if (!response.ok) {
        throw new Error(`Erro na API de frete: ${response.status}`);
      }
      return response.json();
    });
}

// Função para montar e exibir as opções de frete com layout em duas linhas
function displayShippingRates(rates) {
  if (!responseRatesContainer) return;
  
  // Se o array estiver vazio, mantém o estado "Calculando..."
  if (!rates || rates.length === 0) {
    responseRatesContainer.innerHTML = "<p>Calculando...</p>";
    return;
  }
  
  // Monta o HTML usando uma lista não ordenada
  let html = '<ul class="shipping-rates-list" style="list-style:none; margin:0; padding:0;">';
  
  rates.forEach(rate => {
    const name = rate.name || "";
    let prazo = "";
    if (rate.delivery_days && Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0) {
      const minDias = rate.delivery_days[0];
      const maxDias = rate.delivery_days[1] || minDias;
      if (minDias === maxDias) {
        prazo = `Entrega em até ${minDias} dias úteis`;
      } else {
        prazo = `Entrega em ${minDias} a ${maxDias} dias úteis`;
      }
    } else if (rate.delivery_range && Array.isArray(rate.delivery_range) && rate.delivery_range.length === 2) {
      prazo = `Entrega entre ${rate.delivery_range[0]} e ${rate.delivery_range[1]}`;
    } else if (rate.description) {
      prazo = rate.description;
    }
    
    const price = parseFloat(rate.price) === 0
      ? "Grátis"
      : `R$ ${parseFloat(rate.price).toFixed(2).replace('.', ',')}`;
    
    html += `
      <li class="shipping-option-container-pdp" style="border-bottom: 1px solid #eaeaea;">
        <div class="shipping-option-header-pdp" style="display:flex; justify-content:space-between; align-items:center;">
          <span class="shipping-name-pdp" style="font-weight:600; color:#333;">${name}</span>
          <span class="shipping-price-pdp" style="font-weight:600; color:#333;">${price}</span>
        </div>
        <div class="shipping-delivery-pdp">${prazo}</div>
      </li>
    `;
  });
  
  html += "</ul>";
  responseRatesContainer.innerHTML = html;
}

// Função principal de cálculo de frete na PDP
function calculateShipping() {
  // Obtém o CEP salvo e atualiza o campo para exibir para o usuário
  const cep = getSavedCep().trim();
  if (cep && cepInput) {
    cepInput.value = cep;
  }
  
  if (responseRatesContainer) {
    responseRatesContainer.innerHTML = "<p>Calculando...</p>";
  }
  
  if (!cep) {
    responseRatesContainer.innerHTML = "<p>Digite seu CEP para calcular o frete.</p>";
    return;
  }
  
  fetchCart()
    .then(cart => {
      if (cart.item_count === 0) {
        return addTemporaryProduct().then(() => cart);
      }
      return cart;
    })
    .then(() => fetchShippingRates(cep))
    .then(ratesData => {
      displayShippingRates(ratesData.shipping_rates);
    })
    .catch(error => {
      console.error("Erro ao calcular frete:", error);
      responseRatesContainer.innerHTML = "<p>Calculando...</p>";
    })
    .finally(() => {
      // Aguarda 2 segundos antes de remover o produto temporário
      setTimeout(() => {
        removeTemporaryProduct().catch(err => console.error("Erro ao remover produto temporário:", err));
      }, 2000);
    });
}

// Inicialização automática na PDP se CEP já estiver salvo
document.addEventListener("DOMContentLoaded", function() {
  const savedCep = getSavedCep();
  if (savedCep) {
    calculateShipping();
  }
  
  if (estimateBtn) {
    estimateBtn.addEventListener("click", function() {
      const cep = cepInput.value.trim();
      if (cep) {
        saveCep(cep);
        calculateShipping();
      } else {
        alert("Por favor, digite um CEP válido.");
      }
    });
  }
  
  if (cepInput) {
    cepInput.addEventListener("keypress", function(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        const cep = cepInput.value.trim();
        if (cep) {
          saveCep(cep);
          calculateShipping();
        } else {
          alert("Por favor, digite um CEP válido.");
        }
      }
    });
  }
});
